import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Chaplin from "chaplin";
import Utils from "models/helper/Utils";
import Songs from "collections/myLibrary/SongsTabContentCollection";
import SongListView from "views/common/SongListView";
import SongListView2 from "views/common/SongListView2";
import TrebbleClientAPIHelper from "models/helper/TrebbleClientAPI";
import PlayerService from "services/PlayerService";
import PersistentModels from "services/PersistentModels";
import ti18n from "i18n!nls/Commoni18n";
import RSVP from "rsvp";

Songs.prototype.model = PersistentModels.getInstance().getSongContructorFunctionForCollection();
const SongListController = Chaplin.Controller.extend({

    initialize : function(options) {
        _.extend(this, Backbone.Events);
        if(options)
        {
            if(options.model)
            {
                if(Utils.getInstance().is("Array",options.model))
                {
                    const songsJsonArray = options.model;
                    this.model = new Songs(songsJsonArray);
                }else{
                        this.model = options.model;
                }
                
            }
            
            if(options.resizePlaceHolderElem)
            {
                this.resizePlaceHolderElem = options.resizePlaceHolderElem;
            }else{
                this.resizePlaceHolderElem = false;
            }
            if(options.showEmtptyInfoBox){
                this._showEmtptyInfoBox = options.showEmtptyInfoBox;
            }
            if(options.loadHandler)
            {
                this._loadHandler = options.loadHandler;
            }
            if(options.context){
                if(this.model instanceof Songs){
                    this.model.updateContext(options.context);
                }
                this._modelContext = options.context;
            }
            if(options.customInfoBoxInfoParams){
                this._customInfoBoxInfoParams = options.customInfoBoxInfoParams;
            }
            if(options.container$elForImageLazyLoad){
                this._container$elForImageLazyLoad = options.container$elForImageLazyLoad;
            }
            
            this._doNotSortDisplayedCollection = options.doNotSortDisplayedCollection;
            if(options.sortDescending){
                this._sortDescending = options.sortDescending;
            }
            if(!this._doNotSortDisplayedCollection && options.sortField ){
                this._sortField = options.sortField;
                if(this.model){
                    this.model.sortByField(this._sortField, this._sortDescending);
                }
            }
            this._defaultHeightElement = (options && options.defaultHeightElement)? options.defaultHeightElement: null;
            this._customListClass = (options && options.customListClass)? options.customListClass: null;
            this._songWithAudioPreviewOnly = (options && options.songWithAudioPreviewOnly)? options.songWithAudioPreviewOnly: false; 
            this._doNotShowAddToRadioButton = options.doNotShowAddToRadioButton;
            this._doNotShowGradeSongButton = options.doNotShowGradeSongButton;
            this._actionExecutedOnSongHandler = options.actionExecutedOnSongHandler;
            this._container$elForImageLazyLoad = options.container$elForImageLazyLoad;
            this._doNotInitializeLazyLoadingAtRender = options.doNotInitializeLazyLoadingAtRender;
            this._showSongCoverImage = options.showSongCoverImage;
            this._actionItemButtonClass = options.actionItemButtonClass;
            this._userNewSongList = options.userNewSongList;
            this._heightMargin = options.heightMargin;
            this._customOnSongActionButtonTapped = options.onSongActionButtonTapped;
            this._customOnItemTapped = options.onItemTapped;
            this._customOnCapsuleIconTapped = options.onCapsuleIconTapped;
            this._onPostItemRenderedHandler = options.onPostItemRenderedHandler;
            
        }
    },

    getModel : function() {
        return this.model;
    },

    getView : function() {
        return this.view;
    },
    
    clearQueueAndSongAndRestToQueue : function(model, diplayedCollection){
        const isMusicCurrentlyPlaying =  PlayerService.getInstance().isMusicPlaying();
        PlayerService.getInstance().clearQueueAndSongToQueue(model, this._buildPlayListName(), diplayedCollection.getContext());
        if(!isMusicCurrentlyPlaying)
        {
            PlayerService.getInstance().playFirstSongInQueue();
        }
        window.setTimeout((function(){
            const backboneModel =  this.diplayedCollection.get(model.get("uri"));
            PlayerService.getInstance().addSongsToQueue(this.diplayedCollection.getSongsAfter(backboneModel), true);
        }).bind({"diplayedCollection": diplayedCollection}),0);
        
    },
    
    onItemTapped : function(model, diplayedCollection){
        if(this._customOnItemTapped){
            this._customOnItemTapped(model, diplayedCollection);
        }else{
            this.clearQueueAndSongAndRestToQueue(model, diplayedCollection);
        }
    },
    
    _buildPlayListName : function(){
        if(this.view.isSearchApplied()){
            const searchKey = this.view.getAppliedSearchCharacters();
            return window.getI18n(ti18n, "SEARCH_RESULTS_FROM")+ " \""+searchKey+"\" "+ window.getI18n(ti18n, "IN_MY_SONG_LIBRARY");
        }else{
            return window.getI18n(ti18n, "ALL_MUSIC_FROM_MY_SONG_LIBRARY");
        }
    },
    
    showMenuOption : function(songModelTapped){
        PersistentModels.getInstance().getRouter().showSongMenuOption(songModelTapped, this._modelContext,null,this.onActionExecutedOnSongHandler.bind(this));
    },
    
    onSongActionButtonTapped : function(songModelTapped){
        if(this._customOnSongActionButtonTapped){
            this._customOnSongActionButtonTapped(songModelTapped);
        }else{
            this.showMenuOption(songModelTapped);
        }
    },
    onActionExecutedOnSongHandler : function(songModel, action){
        if(this._actionExecutedOnSongHandler){
            this._actionExecutedOnSongHandler(songModel, action);
        }
    },
    
    removeSongFromCollection:function(songModel){
        if(songModel){
            this.model.remove(songModel);
            this.reload();
        }
    },
    
    updateListOfSongs : function(arrayOfSongsJson){
        this.model.reset(arrayOfSongsJson/*, {silent: true}*/);
    },
    
    
     updateInfoBoxIfApplicable : function(iconClass,message,helpMessage,infoBoxClassName,actionButtonLabel,actionButtonIconClass){
            if(this.view){
                this.view.updateInfoBoxIfApplicable(iconClass,message,helpMessage,infoBoxClassName,actionButtonLabel,actionButtonIconClass);
            }
    },
    
    reload : function(){
        if(this.view && this.view.load){
            return this.view.load();
        }else{
            return  RSVP.Promise.resolve();
        }
    },
    
    onSongRemovedFromTrebble : function(songModel){
        this.onActionExecutedOnSongHandler(songModel,"songRemovedFromTrebble");
    },
    
    onCapsuleIconTapped : function(songModel){
        if(this._customOnCapsuleIconTapped){
            this._customOnCapsuleIconTapped(songModel, this._modelContext);
        }else{
            return PersistentModels.getInstance().getRouter().showCapsulesForSong(songModel, this._modelContext);
        }
        
    },
    
    grade : function(songModel){
        PersistentModels.getInstance().getRouter().showSongTagManagerPopup(songModel, this.context);
        
    },
    
    
    addToRadio : function(songModel){
        return PersistentModels.getInstance().addSongToDefaultRadio(songModel, this.context);
    },
    

    
    removeFromRadio : function(songModel){
        return PersistentModels.getInstance().removeSongFromDefaultRadio(songModel, this.context).then((function(){
            this.onSongRemovedFromTrebble(songModel);
        }).bind(this));
    },
    

    initializeImageLazyLoadPlugin : function(container$elForImageLazyLoad){
        this.infiniteListView.initializeImageLazyLoadPlugin(container$elForImageLazyLoad);
    },
    
    cancelPendingImageLoading : function(){
        this.view.cancelPendingImageLoading();
    },
    
     filterList: function(searchCharaterers, filterOptions, sortOptions){
         if(this.view){
             this.view.filterList(searchCharaterers,null, filterOptions, sortOptions);
         }
     },
     
     clearSearchfilter : function(){
         if(this.view){
             this.view.clearSearchfilter();
         }
     },
     
     _onPostItemRendered :function(elem, templateData){
        if(this._onPostItemRenderedHandler){
            this._onPostItemRenderedHandler(elem, templateData);
        }
     },
     
     updateModels : function(newModels){
         this.view.updateModels(newModels);
    },

    updateModel : function(newModel, silent){
        this.view.updateModel(newModel,silent);
    },

    updateContext : function(newContext){
        this._modelContext=newContext;
        if(this.model && this._modelContext){
            this.model.updateContext(this._modelContext);
        }
    },
    
    
    buildModelAndRenderView : function() {
        return new RSVP.Promise((function(resolve, reject) {
            try {
                if(!this.model)
                {
                    this.model = new Songs([]);
                    if(this._modelContext){
                        this.model.updateContext(this._modelContext);
                    }
                }
                this.model.sortByField(this._sortField, this._sortDescending);
                if(this._showSongCoverImage || this._actionItemButtonClass || this._userNewSongList){
                    this.view = new SongListView2({
                        "collection" : this.model,
                        "delayOnCollectionUpdate" : 1000,
                        "resizeToAvailableScreenSizeOnOrientationChange" : false,
                        "resizePlaceHolderElem" : this.resizePlaceHolderElem,
                        "loadHandler" : this._loadHandler,
                        "heightMargin": this._heightMargin,
                        "showEmtptyInfoBox" :this._showEmtptyInfoBox ,
                        "doNotShowSongCoverImage" : !this._showSongCoverImage,
                        "customInfoBoxInfoParams": this._customInfoBoxInfoParams,
                        "container$elForImageLazyLoad": this._container$elForImageLazyLoad,
                        "doNotInitializeLazyLoadingAtRender" : this._doNotInitializeLazyLoadingAtRender,
                        "actionItemButtonClass": this._actionItemButtonClass,
                        "onPostItemRendered" : this._onPostItemRendered.bind(this),
                        "defaultHeightElement": this._defaultHeightElement,
                        "customListClass" : this._customListClass,
                        "doNotShowAddToRadioButton" :  this._doNotShowAddToRadioButton,
                        "doNotShowGradeSongButton" : this._doNotShowGradeSongButton,
                        "songWithAudioPreviewOnly": this._songWithAudioPreviewOnly,
                    });
                    this.listenTo(this.view, "songInfoTapped",this.onItemTapped.bind(this));
                    this.listenTo(this.view, "songActionButtonTapped",this.onSongActionButtonTapped.bind(this));
                    this.listenTo(this.view, "capsuleActionButtonTapped",this.onCapsuleIconTapped.bind(this));
                    this.listenTo(this.view, "songRemovedFromTrebble", this.onSongRemovedFromTrebble);
                    this.listenTo(this.view, "addToRadioButtonTapped", this.addToRadio.bind(this));
                    this.listenTo(this.view, "removeFromRadioButtonTapped", this.removeFromRadio.bind(this));
                    this.listenTo(this.view, "gradeButtonTapped", this.grade.bind(this));
                }else{
                    this.view = new SongListView({
                        "collection" : this.model,
                        "delayOnCollectionUpdate" : 1000,
                        "resizeToAvailableScreenSizeOnOrientationChange" : false,
                        "resizePlaceHolderElem" : this.resizePlaceHolderElem,
                        "loadHandler" : this._loadHandler,
                        "heightMargin": this._heightMargin,
                        "showEmtptyInfoBox" :this._showEmtptyInfoBox ,
                        "customInfoBoxInfoParams": this._customInfoBoxInfoParams,
                        "defaultHeightElement": this._defaultHeightElement,
                        "customListClass" : this._customListClass,
                        "songWithAudioPreviewOnly": this._songWithAudioPreviewOnly
                    });
                    this.listenTo(this.view, "itemTaped",this.onItemTapped);
                    this.listenTo(this.view, "itemOptionBtnTapped", this.onSongActionButtonTapped.bind(this));
                    this.listenTo(this.view, "songRemovedFromTrebble", this.onSongRemovedFromTrebble.bind(this));
                    this.listenTo(this.view, "capsuleActionButtonTapped",this.onCapsuleIconTapped.bind(this));
                    this.listenTo(this.view, "addToRadioButtonTapped", this.addToRadio.bind(this));
                    this.listenTo(this.view, "removeFromRadioButtonTapped", this.removeFromRadio.bind(this));
                    this.listenTo(this.view, "gradeButtonTapped", this.grade.bind(this));
                }
                this.view.render();
                resolve();
            } catch (error) {
                reject(error);
            }

        }).bind(this));

    }

});

export default SongListController;